import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { ImportErrorMessage } from '@usf/product-types';

@Component({
  selector: 'app-non-usf-product-import-toast',
  templateUrl: './non-usf-product-import-toast.component.html',
  styleUrls: ['./non-usf-product-import-toast.component.scss'],
})
export class NonUsfProductImportToastComponent {
  @Input() platform: PlatformEnum;
  @Input() errorMessages: ImportErrorMessage[];
  @Output() dismissToastEvent: EventEmitter<void> = new EventEmitter();
  @Output() openNonUsfProductErrorsModalEvent: EventEmitter<void> =
    new EventEmitter();
  platformRef = PlatformEnum;
  constructor() {}

  dismissToast = () => {
    this.dismissToastEvent.emit();
  };

  openModal = () => {
    this.openNonUsfProductErrorsModalEvent.emit();
  };
}
